/* ============================================================
   DC06 Pack Selector — shared module (window.DC06)
   Production buy box on the Snacking Dough PDP (the test's V3 won;
   productionized 2026-08-11). Loaded before dc06-v3.js. Exposes the
   data layer, price engine, ReCharge helpers (lifted from DC02/DC03),
   the multi-line add-to-cart helper, and the build-your-own-box
   engine that dc06-v3.js initialises.
   ============================================================ */
(function () {
  if (window.DC06) return;

  /* -----------------------------------------------------------
     Price engine — mirrors the real backend charge EXACTLY
     (verified against live /cart/add.js, 2026-07-20):
     - Tier automatic discounts (10-tier 15%, 15-tier 22%) apply to
       BOTH one-time and subscription lines.
     - Subscription: the ReCharge selling plan prices each unit at
       -10% first (half-up rounding), then the tier discount stacks.
     - Shopify allocates tier discounts PER UNIT with floor rounding:
       discount = floor(unit_price * pct / 100) * quantity. The box
       is N single-jar lines, so all math is per unit:
         one-time 3995 / 6800 / 9360 · sub 3595 / 6120 / 8415
     DISPLAY values only — checkout always charges the real backend
     numbers. The engine runs on pricing() below: dynamic by default
     (values delivered via the #dc06-data JSON — per-jar price + plan %
     read live from the catalogue by the Liquid, tier %s + threshold
     from Theme settings -> DC06 Pack Selector). These constants are the
     kill-switch state (toggle off) and the safety net for missing or
     malformed emitted values.
  ----------------------------------------------------------- */
  var BASE_PER_JAR = 799; // cents (uniform per-jar price, pre-discount)
  var TIERS = { 5: 0, 10: 15, 15: 22 }; // tier % off, same in both purchase modes
  var SUB_PLAN_PCT = 10;                // ReCharge selling plan % (stacks on top for subscriptions)

  var SUBSCRIBE_BENEFITS =
    '<ul>' +
    '<li><p>Change flavor as you like, anytime.</p></li>' +
    '<li><p>No commitment. Change or Cancel anytime</p></li>' +
    '<li><p>Free Shipping. All the time.</p></li>' +
    '</ul>';

  /* ---------- data ---------- */
  var _data = null;
  function data() {
    if (_data) return _data;
    try {
      var el = document.getElementById('dc06-data');
      _data = el ? JSON.parse(el.textContent) : { flavors: [] };
    } catch (e) {
      try { console.warn('[DC06] data JSON parse failed — selector will not mount, native buy box stays:', e); } catch (e2) {}
      _data = { flavors: [] };
    }
    return _data;
  }
  function flavors() { return (data().flavors || []); }
  function flavorByName(name) {
    return flavors().filter(function (f) { return f.name === name; })[0] || null;
  }
  /* The builder product's ReCharge plan ("1 month, 10%"). */
  function sellingPlanId() {
    return data().builderSellingPlanId;
  }
  function freeShipFrom() { return Number(data().freeShipFrom) || 10; }

  /* Numbers the price engine runs on (see the constants block above).
     0 is a legitimate value (a tier without a discount), hence the
     null/NaN check rather than ||. */
  function num(v, fb) { var n = Number(v); return v == null || !isFinite(n) ? fb : n; }
  function pricing() {
    var p = data().pricing || {};
    if (!p.dynamic) return { basePerJar: BASE_PER_JAR, tiers: TIERS, subPlanPct: SUB_PLAN_PCT };
    return {
      basePerJar: num(p.basePerJar, BASE_PER_JAR),
      tiers: { 5: 0, 10: num(p.tier10Pct, TIERS[10]), 15: num(p.tier15Pct, TIERS[15]) },
      subPlanPct: num(p.subPlanPct, SUB_PLAN_PCT)
    };
  }

  /* <img> for a flavor: uses the clean override image, falling back to the
     catalogue image if the override file isn't present (onerror). */
  function imgHTML(f, cls) {
    var src = f.image || f.imageFallback || '';
    var fb = f.imageFallback || '';
    var onerr = (fb && fb !== src) ? ' onerror="this.onerror=null;this.src=\'' + fb + '\'"' : '';
    return '<img class="' + cls + '" src="' + src + '" alt="' + (f.name || '') + '" loading="lazy"' + onerr + '>';
  }

  /* ---------- money / prices ---------- */
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function computePrices(opts) {
    opts = opts || {};
    var packSize = Number(opts.packSize) || 0;
    var mode = opts.mode === 'subscription' ? 'subscription' : 'onetime';
    var P = pricing();
    var pct = P.tiers[packSize] || 0;
    var compareTotal = P.basePerJar * packSize;        // full price (strike-through)
    /* N single-jar units; plan % and floor(tier %) apply per unit. */
    var u = P.basePerJar;
    if (mode === 'subscription') u = Math.round(u * (100 - P.subPlanPct) / 100);
    var unitFinal = u - Math.floor(u * pct / 100);
    var total = unitFinal * packSize;
    var perJar = unitFinal;
    return {
      packSize: packSize,
      mode: mode,
      total: total,
      perJar: perJar,
      compareTotal: compareTotal,
      savingsPct: pct, // tier % — drives the Save pills (none at 5, 15%, 22%)
      totalSavingsPct: compareTotal ? Math.round((1 - total / compareTotal) * 100) : 0
    };
  }

  /* ---------- ReCharge widget (shadow DOM) ---------- */
  function widgetEl() { return document.querySelector('recharge-subscription-widget'); }

  /* Read whether the widget is on subscription or one-time. */
  function getSubscriptionChoice() {
    try {
      var w = widgetEl();
      if (!w || !w.shadowRoot) return null;
      var selected = w.shadowRoot.querySelector('.rc-purchase-option[rc-selected]');
      if (!selected) return null;
      if (selected.classList.contains('rc-purchase-option__subscription')) return 'subscription';
      if (selected.classList.contains('rc-selection__onetime')) return 'onetime';
      return null;
    } catch (e) { return null; }
  }

  /* Observe sub/one-time toggle changes + safety poll. */
  function onSubscriptionChange(cb) {
    var last = null;
    function fire() {
      var c = getSubscriptionChoice();
      if (c && c !== last) { last = c; try { cb(c); } catch (e) {} }
    }
    var wire = setInterval(function () {
      var w = widgetEl();
      if (!w || !w.shadowRoot) return;
      new MutationObserver(fire).observe(w.shadowRoot, {
        attributes: true, attributeFilter: ['rc-selected', 'rc-not-selected'], subtree: true
      });
      clearInterval(wire);
      fire();
    }, 300);
    setTimeout(function () { clearInterval(wire); }, 15000);
    var poll = setInterval(fire, 400);
    setTimeout(function () { clearInterval(poll); }, 20000);
  }

  /* Override ReCharge config before the widget initialises.
     opts.mode: 'subscription' | 'onetime' -> default selection / order. */
  function overrideRecharge(opts) {
    opts = opts || {};
    var mode = opts.mode === 'subscription' ? 'subscription' : 'onetime';
    function apply(cfg) {
      cfg.defaultSelection = mode;
      cfg.firstSelectionOption = mode;
      cfg.badgeText = opts.badgeText || 'EXTRA {maxDiscount} OFF';
      cfg.benefits = opts.benefits || SUBSCRIBE_BENEFITS;
    }
    try {
      var root = window.SubscriptionWidgetConfig;
      if (!root) return;
      var cfgs = root.configs;
      if (cfgs && cfgs.subscription_widget_v2 && cfgs.subscription_widget_v2.default_widget_config) {
        var splits = cfgs.subscription_widget_v2.default_widget_config.ab_splits;
        if (splits) splits.forEach(function (s) {
          (s.display_configs || []).forEach(function (dc) { apply(dc.config_information); });
        });
      }
      if (root.preview_config && root.preview_config.preview_config) apply(root.preview_config.preview_config);
    } catch (e) {}
  }

  /* Force the widget's selected purchase option to match mode. The config
     patch (overrideRecharge) only wins if it runs before the widget
     initialises — the widget's script loads independently, so this module
     can lose that race and the widget comes up one-time. So: once the
     widget exists, click the wanted option until the choice matches, then
     stop (user toggles afterwards are respected). */
  function forceRechargeSelection(mode) {
    var want = mode === 'subscription' ? 'subscription' : 'onetime';
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (tries > 40) return clearInterval(iv);
      try {
        if (getSubscriptionChoice() === want) return clearInterval(iv);
        var w = widgetEl();
        if (!w || !w.shadowRoot) return;
        var sel = want === 'subscription'
          ? '.rc-purchase-option__subscription'
          : '.rc-purchase-option.rc-selection__onetime';
        var opt = w.shadowRoot.querySelector(sel);
        if (!opt) return;
        var input = opt.querySelector('input');
        (input || opt).click();
      } catch (e) {}
    }, 250);
  }

  /* Append a <style> into the widget shadow root (retry until present). */
  function injectShadowStyle(id, css) {
    var stop = false;
    function tryInject() {
      if (stop) return true;
      var w = widgetEl();
      if (!w || !w.shadowRoot) return false;
      if (w.shadowRoot.getElementById(id)) { stop = true; return true; }
      var s = document.createElement('style');
      s.id = id;
      s.textContent = css;
      w.shadowRoot.appendChild(s);
      stop = true;
      return true;
    }
    if (tryInject()) return;
    var iv = setInterval(function () { if (tryInject()) clearInterval(iv); }, 400);
    setTimeout(function () { clearInterval(iv); }, 15000);
  }

  /* Hide the widget's own price (we render our own pricing). */
  function hideRechargePrice() {
    injectShadowStyle('dc06-rc-price-hide',
      '[part*="price"], .rc-option__price, .rc-price, [class*="price"] { display: none !important; }');
  }

  /* DC02 benefit-list restyle (checkmark bullets). */
  function styleRcBenefits() {
    var stop = false;
    function tryStyle() {
      if (stop) return true;
      var w = widgetEl();
      if (!w || !w.shadowRoot) return false;
      var rc = w.shadowRoot.querySelector('rc-benefits');
      if (!rc || !rc.shadowRoot) return false;
      if (rc.shadowRoot.getElementById('dc06-benefits-styles')) { stop = true; return true; }
      if (!rc.shadowRoot.querySelectorAll('.rc-benefits__list li').length) return false;
      var s = document.createElement('style');
      s.id = 'dc06-benefits-styles';
      s.textContent =
        'li:not(:last-of-type){margin-bottom:7px !important;}' +
        '.rc-benefits__list li p{margin-top:8px !important;}' +
        '.rc-benefits__list li::before{' +
          '-webkit-mask-image:none !important;mask-image:none !important;background-color:transparent !important;' +
          "background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23000'/%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' fill='%23fff'/%3E%3C/svg%3E\") !important;" +
          'background-size:contain !important;background-repeat:no-repeat !important;}';
      rc.shadowRoot.appendChild(s);
      stop = true;
      return true;
    }
    if (tryStyle()) return;
    var iv = setInterval(function () { if (tryStyle()) clearInterval(iv); }, 500);
    setTimeout(function () { clearInterval(iv); }, 15000);
  }

  /* ---------- Decorate ReCharge widget ----------
     Overrides the widget's per-jar prices with the selected pack's TOTALS and
     replaces the subscribe benefit list (Save X% / conditional free shipping /
     no commitment / delivery every 30 days). Re-applied on an interval because
     ReCharge re-renders its (open) shadow DOM on interaction. DISPLAY ONLY —
     the real subscription charge depends on the ReCharge selling plans. */
  var _rc = { packSize: null, started: false, subFirst: false };

  /* Replace the digit-bearing text node inside a node, preserving sibling
     visually-hidden spans / lit comment nodes. */
  function setDigitText(el, text) {
    if (!el) return;
    var set = false;
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && /[\d$]/.test(n.nodeValue)) { if (n.nodeValue !== text) n.nodeValue = text; set = true; }
    }
    if (!set) el.appendChild(document.createTextNode(text));
  }

  function rcBenefitsHTML(packSize, saveText) {
    var ship = packSize >= freeShipFrom()
      ? '<li class="dc06-rc-yes">Free shipping</li>'
      : '<li class="dc06-rc-no">Free shipping on ' + freeShipFrom() + ' pack or more</li>';
    return '<ul class="dc06-rc-benefits">' +
      '<li class="dc06-rc-yes">' + saveText + '</li>' +
      ship +
      '<li class="dc06-rc-yes">No commitment. Change or Cancel anytime</li>' +
      '<li class="dc06-rc-yes">Delivery every 30 days</li>' +
      '</ul>';
  }

  function decorateRecharge() {
    var w = widgetEl(); if (!w || !w.shadowRoot) return;
    var sr = w.shadowRoot;
    var packSize = _rc.packSize; if (!packSize) return;

    injectShadowStyle('dc06-rc-style',
      'rc-benefits,rc-selling-plans{display:none !important;}' +
      '.rc-purchase-option__badge{background:#0f866a !important;color:#fff !important;}' +
      '.dc06-rc-benefits{list-style:none;margin:12px 0 0;padding:0;}' +
      '.dc06-rc-benefits li{display:flex;align-items:center;gap:10px;font-weight:600;font-size:15px;margin:9px 0;color:#121212;}' +
      '.dc06-rc-benefits li::before{content:"";flex:0 0 auto;width:20px;height:20px;background-size:contain;background-repeat:no-repeat;background-position:center;}' +
      ".dc06-rc-yes::before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23121212' stroke-width='2'%3E%3Ccircle cx='12' cy='12' r='9'/%3E%3Cpath d='M8 12l3 3 5-6'/%3E%3C/svg%3E\");}" +
      '.dc06-rc-no{color:#e60023;}' +
      ".dc06-rc-no::before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23e60023' stroke-width='2'%3E%3Ccircle cx='12' cy='12' r='9'/%3E%3Cpath d='M9 9l6 6M15 9l-6 6'/%3E%3C/svg%3E\");}");

    /* Subscribe-first ordering (V3). Re-asserted every tick because ReCharge
       re-renders its shadow content on selection change and drops our node.
       Margins are zeroed + flex gap used so the boxes keep even spacing
       regardless of visual order (the widget's own margins assume DOM order). */
    if (_rc.subFirst) {
      injectShadowStyle('dc06-rc-subfirst',
        '.rc-selection__root{display:flex;flex-direction:column;gap:12px}' +
        '.rc-selection__root .rc-purchase-option{margin:0 !important}' +
        '.rc-purchase-option__subscription{order:-1}');
    }

    var otp = computePrices({ packSize: packSize, mode: 'onetime' });
    var sub = computePrices({ packSize: packSize, mode: 'subscription' });

    /* Subscribe option: full price struck + subscribe total, badge, benefits.
       Badge/benefit % = TOTAL savings vs full price (plan 10% + tier stacked). */
    var subOpt = sr.querySelector('.rc-purchase-option__subscription');
    if (subOpt) {
      setDigitText(subOpt.querySelector('[part~="rc-purchase-option__original-price"]'), money(sub.compareTotal));
      setDigitText(subOpt.querySelector('[part~="rc-purchase-option__discounted-price"]'), money(sub.total));
      var badge = subOpt.querySelector('.rc-purchase-option__badge');
      if (badge) setDigitText(badge, 'Save up to ' + sub.totalSavingsPct + '%');
      var subc = subOpt.querySelector('.rc-purchase-option__sub-container');
      if (subc && (subc.__dc06Pack !== packSize || !subc.querySelector('.dc06-rc-benefits'))) {
        var old = subc.querySelector('.dc06-rc-benefits'); if (old) old.remove();
        /* 10/15 packs already show tier savings on the card, so the plan's
           % reads as "additional"; the 5 pack has no tier discount. */
        var P = pricing();
        var saveText = P.tiers[packSize] > 0
          ? 'Save an additional ' + P.subPlanPct + '%'
          : 'Save ' + sub.totalSavingsPct + '%';
        subc.insertAdjacentHTML('afterbegin', rcBenefitsHTML(packSize, saveText));
        subc.__dc06Pack = packSize;
      }
    }

    /* One-time option: single price = one-time total, no strike */
    var otpOpt = sr.querySelector('.rc-purchase-option:not(.rc-purchase-option__subscription)');
    if (otpOpt) {
      var box = otpOpt.querySelector('.rc-purchase-option__prices');
      if (box) {
        var disc = box.querySelector('[part~="rc-purchase-option__discounted-price"]') || box.querySelector('.rc-price:not(.strike-through)');
        setDigitText(disc, money(otp.total));
        var strike = box.querySelector('.rc-price.strike-through, [part~="rc-purchase-option__original-price"]');
        if (strike) strike.style.display = 'none';
      }
    }
  }

  /* Set the active pack size and keep the widget decorated (idempotent). */
  function setRechargeContext(ctx) {
    if (ctx && ctx.packSize) _rc.packSize = ctx.packSize;
    decorateRecharge();
    if (!_rc.started) { _rc.started = true; setInterval(decorateRecharge, 400); }
  }

  /* ---------- add to cart (multi-line) ----------
     items: [{ id, quantity, selling_plan?, properties? }] */
  function addToCart(items, opts) {
    opts = opts || {};
    var S = window.MinimogSettings || {};
    var url = (S.routes && S.routes.cart_add_url) || '/cart/add.js';
    var fd = new FormData();
    items.forEach(function (it, i) {
      fd.append('items[' + i + '][id]', it.id);
      fd.append('items[' + i + '][quantity]', it.quantity);
      if (it.selling_plan) fd.append('items[' + i + '][selling_plan]', it.selling_plan);
      if (it.properties) Object.keys(it.properties).forEach(function (k) {
        fd.append('items[' + i + '][properties][' + k + ']', it.properties[k]);
      });
    });
    var sections = (window.FoxKitSections && window.FoxKitSections.length)
      ? window.FoxKitSections.join(',') : 'cart-drawer,cart-count';
    fd.append('sections', sections);
    fd.append('sections_url', window.location.pathname);

    return fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          try { console.warn('[DC06] /cart/add.js rejected:', res.status, res.description || res.message, res); } catch (e) {}
          document.dispatchEvent(new CustomEvent('product-ajax:error', {
            detail: { errorMessage: res.description || res.message }
          }));
          throw res;
        }
        var drawer = document.querySelector('m-cart-drawer');
        var drawerEnabled = !('enable_cart_drawer' in S) || S.enable_cart_drawer;
        if (drawer && opts.open !== false && drawerEnabled) {
          try { drawer.open(); } catch (e) {}
        }
        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: res });
        }
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: res } }));
        return res;
      });
  }

  /* ---------- hero media sync ----------
     Switch the media gallery to a flavor by driving the HIDDEN native
     variant picker: check its flavor radio and dispatch a bubbling change.
     The theme then runs its full native pipeline (section re-fetch swaps
     the gallery to that flavor's media group, URL gets ?variant=..., the
     hidden native price/ATC update). A direct gallery slideTo can't work
     here: only the selected variant's media group is server-rendered.
     Triggered by flavor image/name clicks (pure preview — steppers leave
     the gallery alone by design). Already-checked radios return early, so
     repeat calls for the shown flavor never re-fetch. Returns true once
     applied/decided, false while the picker doesn't exist yet. */
  function setHeroMedia(flavor, root) {
    try {
      if (!flavor) return true;
      var pi = (root && root.closest && root.closest('product-info')) || document.querySelector('product-info');
      var picker = pi && pi.querySelector('variant-picker');
      if (!picker) return false;
      var input = Array.prototype.find.call(
        picker.querySelectorAll('input[type="radio"]'),
        function (i) { return i.value === flavor.name; }
      );
      if (!input) return true;   /* flavor not on this product; nothing to sync */
      if (input.checked) return true;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    } catch (e) { return true; }
  }

  /* ---------- hide the native buy box ----------
     dc06-shared.liquid hides these with CSS gated on html.dc06-on (added
     below in revealVariation once the selector is mounted); the inline
     re-assert here is a backstop against theme scripts re-showing them. */
  var HIDE_NATIVE = [
    '.main-product__block-variant_picker',
    '.main-product__block-price',
    '.main-product__block-buy_buttons',
    '.m-sticky-addtocart'
  ];
  function hideNative() {
    HIDE_NATIVE.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.style.display = 'none'; });
    });
  }
  function revealVariation(root) {
    if (!root) return;
    hideNative();
    root.style.setProperty('display', 'block');
    root.classList.add('dc06-active');
    document.documentElement.classList.add('dc06-on');
  }

  /* ---------- ATC button text ----------
     Free shipping applies from 10 jars up (both tiers above base),
     independent of one-time vs subscribe. */
  function atcText(packSize) {
    return Number(packSize) >= freeShipFrom() ? 'ADD TO CART + FREE SHIPPING' : 'ADD TO CART';
  }

  /* ---------- Build-your-own-box engine ----------
     Mixes single flavors via +/- steppers up to the selected pack size;
     each chosen flavor becomes its own cart line on the builder product
     (its quantity tiers trigger the automatic discounts). opts:
       rootSelector  - '.dc06-v3'
       rechargeMode  - 'onetime' | 'subscription' (default toggle)
       sizes         - [5,10,15]
       freeShipFrom  - pack size at/above which "Free Shipping" shows
     Returns true once initialised (or already), false if deps not ready. */
  function buildBYO(opts) {
    opts = opts || {};
    var root = document.querySelector(opts.rootSelector);
    if (!root || root.dataset.dc06Init) return !!root;
    var FLAVORS = flavors();
    if (!FLAVORS.length) return false;
    root.dataset.dc06Init = '1';

    var SIZES = opts.sizes || [5, 10, 15];
    var BADGES = opts.badges || { 10: { cls: 'popular', text: 'Most Popular' }, 15: { cls: 'best', text: 'Best Value' } };
    var FREE_FROM = opts.freeShipFrom || freeShipFrom();
    var defaultMode = opts.rechargeMode === 'subscription' ? 'subscription' : 'onetime';

    overrideRecharge({ mode: defaultMode });
    forceRechargeSelection(defaultMode);
    if (defaultMode === 'subscription') _rc.subFirst = true;

    var state = { counts: {}, packSize: SIZES[0], mode: defaultMode };
    FLAVORS.forEach(function (f) { state.counts[f.name] = 0; });
    function sum() { return FLAVORS.reduce(function (a, f) { return a + state.counts[f.name]; }, 0); }

    var listWrap = root.querySelector('[data-dc06-list]');
    var sizeWrap = root.querySelector('[data-dc06-sizes]');
    var atc = root.querySelector('[data-dc06-atc]');
    var foot = root.querySelector('[data-dc06-foot]');

    /* Footnote drops the "on N pack or more" qualifier once the selected
       pack already qualifies — it then just confirms "Free shipping". */
    function renderFoot() {
      if (!foot) return;
      foot.textContent = state.packSize >= FREE_FROM
        ? 'Free shipping'
        : 'Free shipping on ' + FREE_FROM + ' pack or more';
    }

    /* Ring the flavor the gallery currently shows (selected-swatch look). */
    function markCurrent(name) {
      listWrap.querySelectorAll('.dc06-list__row').forEach(function (r) {
        r.classList.toggle('dc06-list__row--current', r.getAttribute('data-flavor') === name);
      });
    }

    FLAVORS.forEach(function (f) {
      var row = document.createElement('div');
      row.className = 'dc06-list__row';
      row.setAttribute('data-flavor', f.name);
      row.innerHTML =
        imgHTML(f, 'dc06-list__img') +
        '<span class="dc06-list__name">' + f.name + '</span>' +
        '<span class="dc06-stepper" data-flavor="' + f.name + '">' +
          '<button type="button" data-step="-1" aria-label="Remove ' + f.name + '">−</button>' +
          '<span class="dc06-stepper__count" data-count>0</span>' +
          '<button type="button" data-step="1" aria-label="Add ' + f.name + '">+</button>' +
        '</span>';
      listWrap.appendChild(row);
      row.querySelectorAll('button[data-step]').forEach(function (b) {
        b.addEventListener('click', function () { step(f.name, Number(b.getAttribute('data-step'))); });
      });
      /* Flavor image/name click = gallery preview only (no count change). */
      row.querySelectorAll('.dc06-list__img, .dc06-list__name').forEach(function (el) {
        el.addEventListener('click', function () { setHeroMedia(f, root); markCurrent(f.name); });
      });
    });

    /* Initial ring = the server-selected variant's flavor (what the gallery
       already shows), read from the hidden native picker's checked radio. */
    (function () {
      var pi = (root.closest && root.closest('product-info')) || document.querySelector('product-info');
      var radios = pi ? pi.querySelectorAll('variant-picker input[type="radio"]') : [];
      var checked = Array.prototype.filter.call(radios, function (i) { return i.checked; });
      for (var i = 0; i < checked.length; i++) {
        if (flavorByName(checked[i].value)) { markCurrent(checked[i].value); return; }
      }
    })();

    SIZES.forEach(function (sz) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'dc06-card';
      card.setAttribute('role', 'radio');
      card.dataset.size = String(sz);
      card.addEventListener('click', function () { setPack(sz); });
      sizeWrap.appendChild(card);
    });

    function step(name, delta) {
      if (delta > 0) { if (sum() >= state.packSize) return; state.counts[name]++; }
      else { if (state.counts[name] <= 0) return; state.counts[name]--; }
      renderAll();
    }
    function setPack(sz) {
      if (sum() > sz) FLAVORS.forEach(function (f) { state.counts[f.name] = 0; });
      state.packSize = sz;
      setRechargeContext({ packSize: sz });
      renderAll();
    }

    function renderSteppers() {
      var full = sum() >= state.packSize;
      listWrap.querySelectorAll('.dc06-stepper').forEach(function (st) {
        var name = st.getAttribute('data-flavor');
        st.querySelector('[data-count]').textContent = state.counts[name];
        var plus = st.querySelector('button[data-step="1"]');
        var minus = st.querySelector('button[data-step="-1"]');
        if (plus) plus.disabled = full;
        if (minus) minus.disabled = state.counts[name] <= 0;
      });
    }
    function renderCards() {
      sizeWrap.querySelectorAll('.dc06-card').forEach(function (card) {
        var sz = Number(card.dataset.size);
        var p = computePrices({ packSize: sz, mode: state.mode });
        var badge = BADGES[sz];
        var perks = '';
        if (p.savingsPct > 0 || sz >= FREE_FROM) {
          perks = '<ul class="dc06-card__perks">';
          if (p.savingsPct > 0) perks += '<li>Save ' + p.savingsPct + '%</li>';
          if (sz >= FREE_FROM) perks += '<li>Free Shipping</li>';
          perks += '</ul>';
        }
        card.innerHTML =
          (badge ? '<span class="dc06-card__badge dc06-card__badge--' + badge.cls + '">' + badge.text + '</span>' : '') +
          '<p class="dc06-card__title">' + sz + ' Pack</p>' +
          '<p class="dc06-card__perjar">' + money(p.perJar) + ' / Jar</p>' +
          '<p class="dc06-card__total">' + money(p.total) + '</p>' +
          perks;
        card.setAttribute('aria-checked', sz === state.packSize ? 'true' : 'false');
      });
    }
    function ctaText() {
      var s = sum(), n = state.packSize;
      return s < n ? ('CHOOSE FLAVORS (' + s + '/' + n + ')') : atcText(state.packSize);
    }
    function renderCTAs() {
      var full = sum() === state.packSize;
      var txt = ctaText();
      if (!atc) return;
      atc.disabled = !full;
      var t = atc.querySelector('.m-add-to-cart--text');
      if (t) t.textContent = txt;
    }
    function renderAll() { renderSteppers(); renderCards(); renderCTAs(); renderFoot(); }

    function submit() {
      if (sum() !== state.packSize) return;
      /* Resolve the purchase mode from the live widget at submit time —
         state.mode goes stale if the widget renders after the observer/
         poll windows close. No widget on the page at all means the shopper
         was never shown a subscription choice: fail safe to one-time
         rather than silently enrolling them in a subscription. */
      var mode = getSubscriptionChoice() || (widgetEl() ? state.mode : 'onetime');
      if (mode !== state.mode) { state.mode = mode; renderAll(); }
      var items = [];
      var tag = (opts.tag || 'v2') + ':' + state.packSize;
      FLAVORS.forEach(function (f) {
        if (state.counts[f.name] > 0) {
          var it = { id: f.builderVariantId, quantity: state.counts[f.name], properties: { _dc06: tag } };
          if (mode === 'subscription') it.selling_plan = sellingPlanId();
          items.push(it);
        }
      });
      if (!items.length) return;
      if (atc) atc.disabled = true;
      addToCart(items)
        .then(function () {
          /* Reset the box after a successful add so a second click can't
             cart a duplicate (the drawer covers the button; closing it
             left a full, re-enabled ATC behind). */
          FLAVORS.forEach(function (f) { state.counts[f.name] = 0; });
          renderAll();
        })
        .catch(function () {
          var t = atc && atc.querySelector('.m-add-to-cart--text');
          if (t) t.textContent = 'UNAVAILABLE';
          setTimeout(renderCTAs, 2000);
        });
    }
    if (atc) atc.addEventListener('click', submit);

    /* Adopt the ReCharge purchase-mode options ABOVE the ATC button
       (client request 24.08.26 — shoppers must see Subscribe/One-time
       BEFORE adding; the sub-first default below the button caused
       accidental subscriptions). The widget is a theme app block
       rendered after this snippet's position; its wrapper is
       server-rendered, so the move is deterministic — ReCharge
       injects/upgrades its element inside the container wherever it
       sits, and the already-executed config <script> moving with the
       block does not re-run. If the block is missing, everything
       keeps working with the widget in its original spot. */
    (function () {
      if (!atc) return;
      var pi = (root.closest && root.closest('product-info')) || document;
      var marker = pi.querySelector('.shopify-app-block.recharge-subscription-widget') || widgetEl();
      var block = marker && marker.closest('.main-product__block');
      if (block && !block.contains(atc) && !root.contains(block)) {
        atc.parentNode.insertBefore(block, atc);
      }
    })();

    onSubscriptionChange(function (mode) { state.mode = mode; renderAll(); });

    renderAll();
    setRechargeContext({ packSize: state.packSize });
    revealVariation(root);
    return true;
  }

  window.DC06 = {
    BASE_PER_JAR: BASE_PER_JAR,
    TIERS: TIERS,
    data: data,
    flavors: flavors,
    flavorByName: flavorByName,
    sellingPlanId: sellingPlanId,
    freeShipFrom: freeShipFrom,
    pricing: pricing,
    imgHTML: imgHTML,
    money: money,
    computePrices: computePrices,
    getSubscriptionChoice: getSubscriptionChoice,
    onSubscriptionChange: onSubscriptionChange,
    overrideRecharge: overrideRecharge,
    forceRechargeSelection: forceRechargeSelection,
    injectShadowStyle: injectShadowStyle,
    hideRechargePrice: hideRechargePrice,
    styleRcBenefits: styleRcBenefits,
    setRechargeContext: setRechargeContext,
    setHeroMedia: setHeroMedia,
    addToCart: addToCart,
    hideNative: hideNative,
    revealVariation: revealVariation,
    atcText: atcText,
    buildBYO: buildBYO
  };
})();
